import Form from "@/components/Form";
import LocaleText from "@/components/Intl/LocaleText";

import { ECustomerStress } from "@/helpers/API/requests/interfaces/customer";

import { TPersonalizationStepForm } from "./interfaces";
import Layout from "./Layout";

const Stress: React.FC<TPersonalizationStepForm> = ({ formRef }) => {
  return (
    <Layout title="form.personalizationStep.stress.title">
      {Object.values(ECustomerStress).map((value) => (
        <Form.RadioButton
          key={value}
          name="stress"
          value={value}
          onChanged={() => {
            formRef.current!.next();
          }}
        >
          <LocaleText>{"form.personalizationStep.radio." + value}</LocaleText>
        </Form.RadioButton>
      ))}
    </Layout>
  );
};

export default Stress;
